<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="120" height="120" rx="60" fill="#F18E35" />
    <g clip-path="url(#clip0_19531_255277)">
      <g filter="url(#filter0_d_19531_255277)">
        <path
          d="M34.3928 56.0406C35.8071 54.468 38.1001 54.468 39.5144 56.0406L54.8794 73.1249C56.2937 74.6974 56.2937 77.2471 54.8794 78.8196C53.4651 80.3922 51.172 80.3922 49.7577 78.8196L34.3928 61.7353C32.9785 60.1628 32.9785 57.6131 34.3928 56.0406Z"
          fill="#FEF6E8"
        />
        <path
          d="M49.7531 78.8201C48.3388 77.2476 48.3388 74.6979 49.7531 73.1254L80.483 38.9568C81.8973 37.3842 84.1903 37.3842 85.6046 38.9568C87.0189 40.5293 87.0189 43.079 85.6046 44.6515L54.8747 78.8201C53.4604 80.3927 51.1674 80.3927 49.7531 78.8201Z"
          fill="#FEF6E8"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_19531_255277"
        x="13.332"
        y="21.7773"
        width="93.332"
        height="82.2227"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.987028 0 0 0 0 0.873355 0 0 0 0 0.771164 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_19531_255277"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_19531_255277"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_19531_255277">
        <rect
          width="80"
          height="80"
          fill="white"
          transform="translate(20 20)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "SwooshMobileIcon",
};
</script>

<style scoped></style>
